import config from 'config';

export function parseToStarlink(link?: string): string {
  if (!link) return '';

  const url = new URL(link);

  return `${config.starlink.baseUrl}${url.pathname}`;
}
